<template>
    <div class="bannerfill" ref="bannerfill">
    </div>
    <div class="fixedbanner" ref="fixedbanner">
        <BannerVisual ref="bannervisual"/>
        <NavBar ref="navbar"/>
    </div>
</template>


<script>
import NavBar from './NavBar.vue'
import BannerVisual from './BannerVisual.vue'

export default {
    components: { NavBar, BannerVisual },
    created() {
        window.addEventListener("resize", this.bannerResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.bannerResize);
    },
    mounted() {
        this.bannerResize();
    },
    methods: {
        bannerResize(e) {
            let heightString = (this.$refs.bannervisual.getHeight() + this.$refs.navbar.getHeight()) + 'px';
            this.$refs.bannerfill.style.height = heightString;
        }
    } 
}
</script>


<style scoped>
    .fixedbanner {
        top: 0px;
        position: fixed;
        width: fill;
    }
    .bannerfill {
        padding: 0px;
        margin: 0px;
    }
</style>